import { setActiveTrace } from "@atlassian/wac-ufo-experience-trace-id-context";

import type { MetaTagGetter } from "./types";

let alreadySet = false;

export const retrieveAndSetPageLoadTrace = (getMeta: MetaTagGetter) => {
    // REMOVED: if (__SERVER__ || alreadySet)
    if (alreadySet) return;
    const traceId = getMeta("X-B3-TraceId") || "";
    const sampled = getMeta("X-B3-Sampled") || "";
    const spanId = getMeta("X-B3-SpanId") || "";

    alreadySet = true;

    setActiveTrace(traceId, sampled, spanId, "page_load");
};
